import React, { useEffect, useLayoutEffect, useRef } from "react"
import PropTypes from "prop-types"
import * as styles from "./ImageCardsLayout-tw-styles"
import ImageCard from "../UI/ImageCard/ImageCard"
import Link from "../UI/Link/Link"
import Typography from "../UI/Typography/Typography"
import { get } from "../../helpers/utils"
import Slider from "react-slick"
import { onDotClick } from "../../helpers/slider"
import { compact, last } from "lodash"
import useScreenSize from "../../hooks/useScreenSize"
import { gaImageClick } from "../../constants/gtm.constants"
import { screen, render } from "@testing-library/react"
import Image from "../UI/Image/Image"


const SampleArrow = props => {
  const { eventlabel, className, style, ariaLabel, onClick } = props
  return (
    <button
      className={`${className}`}
      data-action-detail={eventlabel}
      aria-label={ariaLabel}
      aria-hidden="false"
      onClick={onClick}
      style={style}
    />
  )
}

SampleArrow.propTypes = {
  eventlabel: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  ariaLabel: PropTypes.string,
}

export const extractSliderSettings = (settings = {}) => {
  const {
    slidesToShow = 1,
    slidesToScroll = 1,
    slidesToShowTab = 1,
    slidesToScrollTab = 1,
    slidesToShowMobile = 1,
    slidesToScrollMobile = 1,
    dots = false,
    dotsTab = false,
    dotsMobile = false,
    arrows = true,
    arrowsTab = false,
    arrowsMobile = false,
    draggable = true,
    fade = true,
    infinite = false,
    swipe = true,
    centerMode = false,
    variableWidth = false,
    lazyLoad = false,
    autoplay = true,
    autoplaySpeed = 10000,
    initialSlide = 0,
  } = settings

  const dotsListId = Math.round(Math.random() * 1000000)

  const result = {
    dots: !!dots,
    arrows: !!arrows,
    fade: !!fade,
    infinite: !!infinite,
    centerMode: !!centerMode,
    variableWidth: !!variableWidth,
    lazyLoad: !!lazyLoad,
    initialSlide: initialSlide,
    slidesToShow: slidesToShow,
    slidesToScroll: slidesToScroll,
    autoplay: !!autoplay,
    autoplaySpeed: autoplaySpeed,
    focusOnSelect: true,
    draggable: !!draggable,
    pauseOnHover: true,
    nextArrow: (<SampleArrow eventlabel={"ArrowRight"} ariaLabel="right arrow" />),
    prevArrow: (<SampleArrow eventlabel={"ArrowLeft"} ariaLabel="left arrow" />),
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          swipe: true,
          draggable: true,
          swipeToSlide: true,
          slidesToShow: slidesToShowTab,
          slidesToScroll: slidesToScrollTab,
          arrows: !!arrowsTab,
          dots: !!dotsTab,
          appendDots: dots => (
            <ul
              id={dotsListId}
              onClick={() => {
                onDotClick(dotsListId, slidesToShowTab)
              }}
            >
              {dots}
            </ul>
          ),
        },
      },
      {
        breakpoint: 420,
        settings: {
          swipe: true,
          swipeToSlide: true,
          slidesToShow: slidesToShowMobile,
          slidesToScroll: slidesToScrollMobile,
          arrows: !!arrowsMobile,
          dots: !!dotsMobile,
          appendDots: dots => (
            <ul
              id={dotsListId}
              onClick={() => {
                onDotClick(dotsListId, slidesToShowTab)
              }}
            >
              {dots}
            </ul>
          ),
        },
      },
    ],
  }
  return result
}

const ImageCardsLayout = props => {
  const {
    cardsCollection = {},
    text,
    title,
    variant,
    link,
    isSlider,
    eventClass,
    carditems = [],
    sliderSettings = {},
    elementId = "",
    cameoImages = {}
  } = props

  const sliderRef = useRef()
  const screen = useScreenSize()
  // const { slidesToShowTab = 3, slidesToShowMobile = 1.2 } = sliderSettings || {}
  const settings = sliderSettings && extractSliderSettings(sliderSettings)
  const dotsListId = Math.round(Math.random() * 1000000)
  const style = styles[variant] || styles.defaultStyle

  const cameoImagesCollection = screen?.isMobile
  ? [cameoImages?.cameoMediumMobile, cameoImages?.cameoLargeMobile]
  : [cameoImages?.cameoMedium, cameoImages?.cameoLarge]

  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      variant === "FIVE_COLUMN_CARDS_LAYOUT" &&
      screen &&
      !screen.isDesktop
    ) {
      const activeSlide = last(
        compact(document?.location?.pathname?.split("/"))
      )
      const current =
        window?.document?.getElementById(activeSlide)?.parentElement
          ?.parentElement
      const index = Number(current?.getAttribute("data-index"))
      sliderRef?.current?.slickGoTo(index)
    }
  }, [screen])

  

  const cards =
    carditems.length > 0 ? carditems : get(cardsCollection, "items", [])
  const buildSlides = () => {
    return cards?.map((card, index) => {
      return (
        <div key={index} className={style?.linkCardsWrpr} id={card?.elementId}>
          {card?.link && variant !== "THREE_COLUMN_IMAGE_CARDS_LAYOUT" ? (
            <>
              <Link
                {...card.link}
                className={style?.linkWrpr}
                ariaLabel={card?.link?.ariaLabel}
              >
                <ImageCard {...card} />
              </Link>
              {card?.descriptionOutsideLinkTag && (
                <Typography
                  className={style?.descriptionOutsideLinkTag}
                  content={card?.descriptionOutsideLinkTag}
                />
              )}
            </>
          ) : (
            <ImageCard {...card} />
          )}
        </div>
      )
    })
  }


  const buildSlider = () => {
    if (isSlider) {
      return (
        <div className={style?.cardWrpr}>
          <Slider {...settings} className={style?.sliderMob} ref={sliderRef}>
            {buildSlides()}
          </Slider>
        </div>
      )
    } else {
      return <div className={style?.cardsContainer}>{buildSlides()}</div>
    }
  }



  return (
    <div className={style?.mainContainer}>
      <div className={style?.container} id={elementId}>
        {title && <h2 className={style?.heading} >{title}</h2>}
        {text && (
          <Typography
            className={style?.description}
            allow_br_tag={true}
            content={text}
          />
        )}
        {cards?.length > 0 && buildSlider()}
        {link?.label && (
          <div className="text-center">
            <div className={`${style?.btnContainer} "inline-Block"`}>
              <Link {...link} className={style?.btnWrpr} />
            </div>
          </div>
        )}
        {(cameoImages && screen?.isMobile && cameoImages?.cameoMediumMobile) ? <div className={style?.imageWrapperMedium}>
              <Image src={cameoImages?.cameoMediumMobile?.url} /> </div> : <div className={style?.imageWrapperMedium}>
              <Image src={cameoImages?.cameoMedium?.url} />
            </div>
        }{(cameoImages && screen?.isMobile && cameoImages?.cameoLargeMobile) ? <div className={style?.imageWrapperLarge}>
        <Image src={cameoImages?.cameoLargeMobile?.url} /> </div> : <div className={style?.imageWrapperLarge}>
        <Image src={cameoImages?.cameoLarge?.url} />
          </div>
        }
      </div>
    </div>
  )
}

ImageCardsLayout.propTypes = {
  cardsCollection: PropTypes.object,
  text: PropTypes.string,
  title: PropTypes.string,
  variant: PropTypes.string,
  link: PropTypes.object,
  isSlider: PropTypes.bool,
  sliderSettings: PropTypes.object,
  eventClass: PropTypes.string,
  carditems: PropTypes.array,
  elementId: PropTypes.string,
  cameoImages : PropTypes.object
}

export default ImageCardsLayout
